
module dg.objects {

    export class FormControlLayoutController {

        public label: string;
        public objectEditorController: any;
        public propertyId: string;
        public propMeta: dg.restfulApi.DomainObjectPropertyMetadata
        public form: any;

        public totalWidth: number;
        public labelWidth: number;
        public contentWidth: number;
        public propClass: string;
        public rowItems: number;

        $onInit = () => {
            var valueObject = this.objectEditorController.value;
            this.label = valueObject.dgMeta.properties[this.propertyId].displayName;
            this.propMeta = valueObject.dgMeta.properties[this.propertyId];
            this.form = this.objectEditorController.form;

            var rowItems = this.rowItems ? this.rowItems : 1;

            this.totalWidth = 12 / rowItems;

            if (rowItems == 1) {
                this.labelWidth = 3;
            } else if (rowItems == 2) {
                this.labelWidth = 2
            } else if (rowItems == 3 || rowItems == 4 || rowItems == 6) {
                this.labelWidth = 1;
            } else {
                throw Error(`rowItems should be from 1 to 4. '${rowItems}' is invalid value`);
            }

            this.labelWidth = this.labelWidth * rowItems;

            this.contentWidth = 12 - this.labelWidth;
            // this.propClass = scope.propMeta ? 'dg-prop-' + scope.propMeta.propertyType : null;
        }
    }

    angular.module('dg.objects').component('formControlLayout', {
        bindings: {
            propertyId: '@',
            rowItems: '<'
        },
        require: {
            objectEditorController: '^objectEditor'
        },
        controller: FormControlLayoutController,
        templateUrl: '/digmo/src/objects/properties/layouts/form-control-layout.html'
    });
}